import React, { PropsWithChildren } from "react";
//#region types
import { FileConstants } from "utils/constants";
//#endregion
//#region components
import { Portal } from "@mui/material";
//#endregion

const DimensionsDialogFilePortal: React.FC<PropsWithChildren> = (props) => {
  const mount = document.getElementById(FileConstants.DialogFilePreviewPortalId);

  return mount ? <Portal container={mount}>{props.children}</Portal> : <></>;
};

export default DimensionsDialogFilePortal;
